<template>
  <div class="xs-12 m-8">
    <div class="main-tab">
      <h1 class="dea-heading--medium__l dea-text--left">{{ mainTitle }}</h1>
      <ErrorMessage v-if="generalErrorMessage">{{ generalErrorMessage }}</ErrorMessage>
      <slot />
      <div v-if="confirmButtonText" class="main-tab__button">
        <Buttons v-if="condition" class="dea-button--large" @click="sendAction">{{ confirmButtonText }}</Buttons>
        <Buttons v-else disabled class="dea-button--large">{{ confirmButtonText }}</Buttons>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Buttons from "@/components/elements/Buttons";
import ErrorMessage from "@/components/elements/ErrorMessage";

export default {
  name: "MainTab",
  components: { Buttons, ErrorMessage },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    confirmButtonText: {
      type: String,
      default: "",
    },
    action: {
      type: Function,
      default: () => {},
    },
    condition: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(["user", "localFiscalCode", "generalErrorMessage"]),
  },
  methods: {
    sendAction(event) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.action(event);
      }, 200);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.main-tab {
  padding: 0 $space-base;

  &__button {
    display: flex;
    justify-content: flex-end;
    margin-bottom: $space-base;
  }

  &__authorization-box {
    margin-bottom: $space-x-large;
  }

  &__authorization-title {
    margin-bottom: $space-xx-small;
    text-transform: uppercase;
  }

  &__fc-text {
    &--mobile {
      @include media(">xs") {
        display: none;
      }

      span {
        cursor: pointer !important; //sass-lint:disable-line no-important
        text-decoration: underline;
      }
    }

    &--desktop {
      @include media("<xs") {
        display: none;
      }
    }
  }

  &__authorization-text {
    &--mobile {
      @include media(">xs") {
        display: none;
      }

      span {
        cursor: pointer !important; //sass-lint:disable-line no-important
        text-decoration: underline;
      }
    }

    &--desktop {
      @include media("<xs") {
        display: none;
      }
    }
  }
}

.data-container {
  margin-bottom: $space-large !important; //sass-lint:disable-line no-important

  &__block {
    @include media("<=s") {
      margin-bottom: 0 !important; //sass-lint:disable-line no-important
    }
    margin-bottom: $space-base;

    p {
      @include media("<=s") {
        font-size: $h-font-size-xxx-small;
      }

      text-transform: uppercase;
    }
  }

  &__block--email-field {
    word-wrap: break-word;
  }

  &__info {
    display: inline-block;
    position: relative;
  }
}
</style>
